import React from "react";
import { HiX } from "react-icons/hi";
import { FiCreditCard } from "react-icons/fi";
import {
  getGatewayLabel,
  getPaymentButtonsForGateway,
} from "utilities/onlinePaymentFlow";
import PaymentModeButtons from "./PaymentModeButtons";

const SelectedGatewayPaymentPanel = ({
  gateway,
  title = "Payment options",
  subtitle = "Select how you would like to pay",
  onSelect,
  onClose,
}) => {
  const buttons = getPaymentButtonsForGateway(gateway);

  return (
    <div className="overflow-hidden rounded-b-xl bg-white">
      <div className="relative px-5 py-4 bg-gradient-to-r from-slate-800 to-slate-700 text-white">
        <div className="pr-8">
          <h5 className="text-base font-semibold tracking-wide">{title}</h5>
          <p className="mt-1 text-xs text-slate-200">{subtitle}</p>
        </div>
        <button
          type="button"
          className="absolute right-4 top-1/2 -translate-y-1/2 flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-white transition hover:bg-white/25"
          onClick={onClose}
          aria-label="Close"
        >
          <HiX size={18} />
        </button>
      </div>

      <div className="px-4 py-4 bg-slate-50">
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <div className="mb-3 flex items-center gap-2 border-b border-slate-100 pb-3">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 text-slate-600">
              <FiCreditCard size={16} />
            </span>
            <div>
              <div className="text-sm font-semibold text-slate-800">
                {getGatewayLabel(gateway)}
              </div>
              {gateway?.payment_mode && (
                <div className="text-[11px] uppercase tracking-wider text-slate-400">
                  {gateway.payment_mode}
                </div>
              )}
            </div>
          </div>

          <PaymentModeButtons
            buttons={buttons}
            onSelect={(allowedPaymentMode, payMode) =>
              onSelect?.(allowedPaymentMode, payMode)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default SelectedGatewayPaymentPanel;
